import { render, staticRenderFns } from "./TipoBaixaList.vue?vue&type=template&id=341dc6d6"
import script from "./TipoBaixaList.vue?vue&type=script&lang=js"
export * from "./TipoBaixaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports